import React from "react";
// import { Col, Row } from 'reactstrap'
// import { FormattedMessage } from "react-intl";
import { Col, Row } from "reactstrap";

const AddButton = ({ data = "" }) => {
	return (
		<Row>
			<Col lg={4} xs={12}>
				<div className="form-group">
					<button type="submit" className="bt bt-success">
						{/* <FormattedMessage id={"add"} /> */}
						{data || "اضافة"}
					</button>
				</div>
			</Col>
		</Row>
	);
};

export default AddButton;
